<div class="cabinet-block head-block">
  <div class="cabinet-row">
    <div class="cab-done-icon"></div>
    <div class="cabinet-id cabinet-cell">ID</div>
    <div class="cabinet-name cabinet-cell">Name</div>
  </div>
</div>

<div class="cabinet-block"
     *ngFor="let cabinet of cabinets; trackBy: trackEntityById; let isEven = even; let isOdd = odd, let i = index"
     [ngClass]="{'status-ready': cabinet[booleanString], 'created-manually': cabinet.createdManually}">

  <div class="cabinet-row">
    <div class="cab-done-icon" (click)="toggleCabinetStatus(cabinet)">
      <mat-icon matRipple>done</mat-icon>
    </div>

    <div class="cabinet-id cabinet-cell">#{{cabinet.cabinetId}}</div>
    <div class="cabinet-info" *ngIf="!cabinet.createdManually">
      <div class="cabinet-name cabinet-cell"><span *ngIf="cabinet.quantity > 1"
                                                   style="margin-right: 0.2em;">({{cabinet.quantity}})
									QTY</span><span>{{cabinet.cabinetName}}</span></div>
      <div class="cabinet-name cabinet-cell" *ngIf="!cabinet.hardwareGroup">{{cabinet.widthFraction}} x
        {{cabinet.heightFraction}} x
        {{cabinet.depth | number:'1.0-0'}}
      </div>
    </div>

    <div class="cabinet-info manual-created" *ngIf="cabinet.createdManually">
      <div class="cabinet-name cabinet-cell">
        <span>{{cabinet.cabinetName}}</span>
      </div>

      <div class="cabinet-description">
        {{cabinet.description}}
      </div>
    </div>

    <div class="cabinet-icon cabinet-cell"
         *ngIf="!hidingMode && !isMobile && !cabinet.createdManually && !cabinet.hardwareGroup"
         (click)="scrollToFile(cabinet)"
         matRipple>
              <span class="material-icons">
								view_in_ar
							</span>
    </div>

    <div class="cabinet-icon cabinet-cell hide-icon"
         *ngIf="hidingMode && !cabinet.createdManually"
         (click)="hideCabinet(cabinet)"
         [ngClass]="{'confirm-hide': isCabinetMarkedForHiding(cabinet)}"
         matRipple>
      <span class="material-icons">
        {{isCabinetMarkedForHiding(cabinet) ? 'delete_forever' : 'visibility_off'}}
      </span>
    </div>

    <div class="cabinet-icon cabinet-cell manual-icon" *ngIf="cabinet.createdManually">
      <span class="material-icons delete-icon" (click)="deleteCabinet(i)">
        clear
      </span>
    </div>

    <div class="cabinet-icon cabinet-cell notes-icon" (click)="toggleNotes(cabinet)" matRipple>
      <span class="material-icons">
        edit
      </span>
    </div>
  </div>

  <div class="cabinet-notes" *ngIf="shouldShowNotes(cabinet)">
    <div class="notes-display" *ngIf="!isNotesExpanded(cabinet)" (click)="toggleNotes(cabinet)">
      {{cabinet.notes}}
    </div>
    <textarea
      class="notes-textarea"
      *ngIf="isNotesExpanded(cabinet)"
      [value]="cabinet.notes || ''"
      (blur)="updateNotes(cabinet, $any($event.target).value); toggleNotes(cabinet)"
      placeholder="Add notes..."
      maxlength="128"
      autofocus>
    </textarea>
  </div>
</div>
